import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useNotificationSocketStore } from '../lib/notificationSocketStore'
import { NOTIFICATIONS_CONNECTION_LOST } from '../lib/notifications-copy'
import {
  notificationConnectionLostBannerInsetSx,
  notificationConnectionLostBannerSx,
  notificationConnectionLostTextSx,
} from '../styles/notificationConnectionStyles'

type NotificationConnectionLostBannerProps = {
  testId: string
  /** Panel uses inset styling; shell nav and full page use full-width strip. */
  variant?: 'strip' | 'inset'
}

export function NotificationConnectionLostBanner({
  testId,
  variant = 'strip',
}: Readonly<NotificationConnectionLostBannerProps>) {
  const connectionLost = useNotificationSocketStore((s) => s.connectionLost)

  if (!connectionLost) return null

  return (
    <Box
      sx={variant === 'inset' ? notificationConnectionLostBannerInsetSx : notificationConnectionLostBannerSx}
      data-testid={testId}
      role="status"
    >
      <Typography sx={notificationConnectionLostTextSx}>{NOTIFICATIONS_CONNECTION_LOST}</Typography>
    </Box>
  )
}
